export const routeProps = {
  path: '/reset_password',
  exact: true,
};

export default () => routeProps;
